export default {
  Title_Common: {
    System_Platform: '系統平台',
    TiShi: '提示',
    DianZiCheng_SheDing: '電子秤設定',
    YaoPingZhongLiang: '藥品重量',
    KaiShiZhi: '開始值',
    JieShuZhi: '結束值',
    WuCha: '誤差',
    AnZhaoBiLiJiSuan: '按照比例計算',
    NONG_S_System: '農本方中醫診所管理系統',
    Guige_Biaozhun: '規格標準',
    Gonggong_Shuju: '公共數據',
    Zidian_Guanli: '字典管理',
    ZhenJiu_FanFa: '針灸方法',
    ZhenJiu_WeiZhi: '針灸位置',
    YaoPing_GongNeng: '藥品功能',
    YaoPing_PingPai: '藥品品牌',
    ZhiFu_FangShi: '支付方式',
    HuiYuan_LeiBie: '會員類別',
    HuaYan_LeiXing: '化驗類型',
    XinZeng_ZiDian: '新增{name}',
    XiuGai_ZiDian: '修改{name}',
    HaoYuan_GuiZe: '號源規則',
    GuanLi_XiTong: '管理系統',
    ShouYe: '首頁',
    ZhenSuo_GuanLi: '診所管理',
    YuanGong_GuanLi: '員工管理',
    XinZeng_YuanGong_XinXi: '新增員工信息',
    XiuGai_YuanGong_XinXi: '修改員工信息',
    YuanGong_XinXi: '員工信息',
    YuanGong_ChuShi_Hua: '員工初始化',
    QueRen_ChongZhi_MiMa: '確認重置密碼',
    JueSe_QuanXian: '角色權限',
    ZhenSuo_PeiZhi: '診所配置',
    YouHuiQuan: '優惠券',
    YongHu_GuanLi: '用戶管理',
    HuanZhe_GuanLi: '患者管理',
    BiaoQian_LieBiao: '標簽列表',
    ZhuanJieMa: '轉介碼',
    YaoPin_GuanLi: '藥品管理',
    YaoPin_LieBiao: '藥品列表',
    CaiGou_PanDian: '採購盤點',
    YaoPin_CaiGou: '藥品採購',
    YaoPin_PanDian: '藥品盤點',
    YaoPin_TiaoZheng: '藥品調整',
    XiangMu_GuanLi: '項目管理',
    ZhenJiu_GuanLi: '針灸管理',
    TuiNa_ZhengGu: '推拿/正骨',
    BaGuan_GuanLi: '拔罐管理',
    PiPei_YaoWu: '匹配藥物',
    ShangDian_LingShou: '商店零售',
    TaoPiao_GuanLi: '套票管理',
    ShangPin_GuanLi: '商品管理',
    ChaXun_TongJi: '查詢統計',
    KeYuan_YingShou: '客源營收',
    YaoPin_ShiYong_ChengBen_BaoGao: '藥品使用成本報告',
    DuiZhang_Dan: '對賬單',
    DanJu_MingXi_WangJiao: '單據明細(旺角)',
    ZhongYi_ZhenSuo: '中醫診所',
    Zhong: '中',
    ZhenSuo_Duan: '診所端',
    GuanLi_Duan: '管理端',
    PeiSong_SheDing: '配送設定',
    ZhiFu_SheDing: '支付設定',
    PeiYao_SheDing: '配藥設定',
    YongHu_XinXi: '用戶信息',
    XinZeng_YouHuiQuan_XinXi: '新增優惠券信息',
    XiuGai_YouHuiQuan_XinXi: '修改優惠券信息',
    YouHuiQuan_XinXi: '優惠券信息',
    QueRen_QiYong: '確認啟用',
    QueRen_TingYong: '確認停用',
    BingRen_ZiLiao: '病人資料',
    XinZeng_BingRen_ZiLiao: '新增病人資料',
    BianJi_BingRen_ZiLiao: '編輯病人資料',
    ZhengZai_ShanChu_YongHu: '正在刪除用戶',
    TaoCan_GuanLi: '套餐管理',
    XinZeng_TaoCan: '新增套餐',
    ZhenSuo_SheDing: '診所設定',
    PeiSong_DiZhi: '配送地址',
    TianJia_ShouHuo_DiZhi: '添加收貨地址',
    BianJi_ShouHuo_DiZhi: '編輯收貨地址',
    YaoPin_MingXi: '藥品明細',
    DingDan_XiangQing: '訂單詳情',
    QianShou_YaoPin: '簽收藥品',
    DingDan_ShenHe: '訂單審核',
    CaiGou_DingDan: '採購訂單',
    DingDan_QianShou: '訂單簽收',
    YaoPin_XuanZe: '藥品選擇',
    KuCun_TiaoZheng: '庫存調整',
    ChuZhi_Ka: '儲值卡',
    YouHui_GuanLi: '優惠管理',
    XinZeng_ChuZhiKa_XinXi: '新增儲值卡信息',
    BianJi_ChuZhiKa_XinXi: '編輯儲值卡信息',
    ChuZhiKa_XinXi: '儲值卡信息',
    QianMing: '簽名',
    PanDian_XiangQing: '盤點詳情',
    TiaoZheng_XiangQing: '調整詳情',
    PanDian_YuLan: '盤點預覽',
    XiTong_ShouYe: '系統首頁',
    ZhiFu_SheZhi: '支付設置',
    PeiYao_SheZhi: '配藥設置',
    ShouFei_SheZhi: '收費設置',
    ShouFei_XiangMu: '收費項目',
    DaYin: '打印',
    DaYin_SheZhi: '打印設置',
    ShouFei_Zu: '收費組',
    ChuZhi_HuoDong: '儲值活動',
    XinZeng_ChuZhi_HuoDong: '新增儲值活動',
    BianJi_ChuZhi_HuoDong: '編輯儲值活動',
    HuoDong_XinXi: '活動信息',
    ChuZhi_YongHu: '儲值用戶',
    ChangYong_SheDing: '常用設定',
    ChangYong_ChuFang: '常用處方',
    ChangYong_XueWei: '常用穴位',
    ChangYong_FenLei: '常用分類',
    FenLei_ChuFang_Dan: '分類處方單',
    ChuFang_Dan_NeiRong: '處方單內容',
    FenLei_XueWei_Dan: '分類穴位單',
    XueWei_Dan_NeiRong: '穴位單內容',
    BianHao_SheZhi: '編號設置',
    XinZeng_XiangMu: '新增項目',
    XiuGai_XiangMu: '修改項目',
    XinZeng_TaoPiao_XinXi: '新增套票信息',
    XiuGai_TaoPiao_XinXi: '修改套票信息',
    TaoPiao_XinXi: '套票信息',
    ZhenZhi_SheZhi: '診治設置',
    ZhenDuan_ZiLiao_SheDing: '診斷資料設定',
    DaYin_JiLu: '打印記錄',
    RiZhi: '日誌',
    DaYin_RiZhi: '打印日誌',
    DengLu_RiZhi: '登錄日誌',
    PaiBan_SheZhi: '排班設置',
    DiTu: '地圖',
    JiGou_GuanLi: '機構管理',
    RenYuan_GuanLi: '人員管理',
    ShouQuan_GuanLi: '授權管理',
    XiTong_GuanLi: '系統管理',
    JieXi_GuanLi: '解析管理',
    XiaoXi_TongZhi: '消息通知',
    TuiSong_MuBan: '推送模板',
    DiSanFang: '第三方',
    MiYao_GuanLi: '秘鑰管理',
    XinZeng_MiYao: '新增秘鑰',
    XiuGai_MiYao: '修改秘鑰',
    YiShi_MingDan: '醫師名單',
    XinZeng_YaoPin_GuiGe: '新增藥品規格',
    XiuGai_YaoPin_GuiGe: '修改藥品規格',
    YaoPin_PiCi: '藥品批次',
    XinZeng_YaoPin_PiCi: '新增藥品批次',
    XiuGai_YaoPin_PiCi: '修改藥品批次',
    ZhenSuo_LieBiao: '診所列表',
    XuanZe_YonHu: '選擇用戶',
    DiTu_SouXun: '地圖搜尋',
    DaBao_SheDing: '打包設定',
    JianGe_PeiZhi: '間隔配置',
    PaiBan_GuiZe: '排班規則',
    GuiShu: '歸屬',
    HaoYuan_SheZhi: '號源設置',
    HaoYuan_SheDing: '診症號源',
    YiShi_PaiBan: '醫師排班',
    HaoYuan_PaiBan: '號源排班',
    LuYou_GuanLi: '路由管理',
    XinZeng_LuYou: '新增路由',
    XiuGai_LuYou: '修改路由',
    MoKuai_QuanXian: '模塊權限',
    GongNeng_QuanXian: '功能權限',
    QuanXian: '權限',
    HuanZhe_LiBiao: '患者列表',
    YaoPin_KuCun: '藥品庫存',
    XinZeng_YaoPin_KuCun: '新增藥品庫存',
    XiuGai_YaoPin_KuCun: '修改藥品庫存',
    YingShou_GuanLi: '營收管理',
    ShouFei_SheDing: '收費設定',
    ChuZhi_XinXi: '儲值信息',
    XinZeng_PiPei_YaoWu: '新增匹配藥物',
    XiuGai_PiPei_YaoWu: '修改匹配藥物',
    ZhenSuo_LingShou: '零售管理',
    YaoPin_LingShou: '藥品零售',
    XinZeng_ShangPin: '新增商品',
    XiuGai_ShangPin: '修改商品',
    ShangPin_XinXi: '商品信息',
    LingShou_HuoDong: '零售活動',
    XinZeng_LingShou_HuoDong: '新增零售活動',
    XiuGai_LingShou_HuoDong: '修改零售活動',
    XinZeng_PiCi: '新增批次',
    XiuGai_PiCi: '修改批次',
    Yaopin_MuBan: '藥品模板',
    JinJi_MuBan: '禁忌模板',
    YaoWu_HuChi: '配伍禁忌',
    MinGan_JinJi: '敏感禁忌',
    ZuZhi_GuanLi: '組織管理',
    KuCun_ZhuiZong: '庫存追蹤',
    HuaYan_ZhiBiao: '化驗指標',
    HeBing_HuanZhe: '合併患者',
  },
}
